import { authPost } from "../../common/redux/ApiClient";

const baseUrl = process.env.REACT_APP_BASE_URL;

export function postAgent21(params, isDefault) {
  return authPost(`${baseUrl}/Agent21.ashx`, params, undefined, isDefault);
}
